import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import App from './App.vue'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import piniaPersist from 'pinia-plugin-persistedstate'
import { getAccountId, getCouponId, getPlacementId } from '@/utils'

const vuetify = createVuetify({
  components,
  directives,
})

document.querySelectorAll('.coupon-builder-cx').forEach(element => {
  const app = createApp(App, {
    accountId: element.getAttribute('data-account-id') ?? getAccountId(),
    placementId: element.getAttribute('data-placement-id') ?? getPlacementId(),
    couponId: element.getAttribute('data-coupon-id') ?? getCouponId(),
  })

  const pinia = createPinia()
  pinia.use(piniaPersist)

  app.use(pinia)
  app.use(vuetify)
  app.mount(element)
})
